module.exports = __webpack_public_path__ + "static/media/bg15.c2539b91.jpg";